import * as THREE from "three";
import { App, optionsFromLocation } from "./app";
import { DITHER } from "./config";
import { createBoot } from "./ui/hud";
import { mountClock } from "./ui/clock";

declare global {
  interface Window {
    __explorer: App;
  }
}

const canvas = document.getElementById("stage");
if (!(canvas instanceof HTMLCanvasElement)) throw new Error("missing #stage canvas");

const options = optionsFromLocation(window.location);

const edge = new THREE.Color(options.dither?.shadowTint ?? DITHER.shadowTint).multiplyScalar(0.82);
const background = `#${[edge.r, edge.g, edge.b]
  .map((value) => Math.round(Math.min(1, Math.max(0, value)) * 255).toString(16).padStart(2, "0"))
  .join("")}`;

document.documentElement.style.background = background;
document.body.style.background = background;
document
  .querySelector('meta[name="theme-color"]')
  ?.setAttribute("content", background);

await document.fonts.ready;

const boot = createBoot(background);
const fit = (): void => boot.resize(window.innerWidth, window.innerHeight);
fit();
window.addEventListener("resize", fit);

const frame = (): Promise<void> =>
  new Promise((resolve) => {
    requestAnimationFrame(() => resolve());
  });

mountClock();

boot.draw(0);
await frame();

const app = await App.create(canvas, options, (progress) => boot.draw(progress));
window.__explorer = app;
app.start();

const bootCanvas = document.querySelector('[data-role="boot"]');
if (bootCanvas instanceof HTMLElement) {
  bootCanvas.dataset.ready = "true";
  window.setTimeout(() => bootCanvas.remove(), 600);
}
